module.exports = __webpack_public_path__ + "img/icon-purchase-succ.2f0edfb1.png";